const Index = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/dashboard/RelatorioProdutividadePerformance/Index"
  );
const Print = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/dashboard/RelatorioProdutividadePerformance/Print"
  );

export default [
  {
    path: "relatorio-produtividade-performance",
    name: "RelatorioProdutividadePerformance",
    component: Index,
    meta: {
      title: "Relatório Produtividade e Performance",
      ensureCanSeeFunctionalities: true,
      permission: {
        name: "relatorioProdutividadePerformance",
        action: "read"
      }
    }
  },
  {
    path: "relatorio-produtividade-performance/:id/print",
    name: "ImprimirRelatorioProdutividadePerformance",
    component: Print,
    meta: {
      title: "Imprimir Relatório Produtividade e Performance",
      ensureCanSeeFunctionalities: true,
      permission: {
        name: "relatorioProdutividadePerformance",
        action: "read"
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-produtividade-performance.js